import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiConfig} from '@config/api.config';
import {ACCOUNTS_SERVICE, ACCOUNTS_SERVICE_API_VERSION} from '@constants/api.constants';
import {ApiResponse} from '@core/models/api-response.model';
import {endpoint} from '@constants/path.constants';


@Injectable({providedIn: 'root'})
export class AccountsWebservices {
  private readonly baseUrl = ApiConfig.getBaseUrl(ACCOUNTS_SERVICE, ACCOUNTS_SERVICE_API_VERSION);

  constructor(private http: HttpClient) {
  }

  verifyUser(payload: {}) {
    const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
    return this.http.post<ApiResponse<any>>(
      this.baseUrl + endpoint.account.verify_user, payload, {headers}
    );
  }
}
